"use strict";
/*
 * Created on 10 14 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../../core/model/DomainObject");
/**
 * General representation of a data entity to export to a file.
 *
 * @author Jaroslav Sevcik
 */


var SimpleExportedEntity =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SimpleExportedEntity, _DomainObject_1$Domai);

  /**
   * @param id
   * @param dataIdentifier identification of a type of the exported data
   * @param created date of export
   * @param publicPath full public path to an exported file
   * @param path full path to an exported file
   * @param deleted
   */
  function SimpleExportedEntity(id, dataIdentifier, created, publicPath, path, deleted) {
    var _this;

    _classCallCheck(this, SimpleExportedEntity);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SimpleExportedEntity).call(this));
    _this.id = id;
    _this.dataIdentifier = dataIdentifier;
    _this.created = created;
    _this.publicPath = publicPath;
    _this.path = path;
    _this.deleted = deleted;
    return _this;
  }

  return SimpleExportedEntity;
}(DomainObject_1.DomainObject);

exports.SimpleExportedEntity = SimpleExportedEntity;